<template>
  <div class="container is-uppercase has-text-weight-bold">
    <Header/>
    <div style="text-align: center;">
    <img src="@/../static/kfit/home_vid.png" class="image">
    </div>
    <div class="section has-background-primary">
      <div class="has-text-left m-b-md has-text-white" style="width:100%;">
          <p class="m-t-sm m-b-sm">
            อ่านสถิติของคุณและปลดล็อกกิจวัตรการฝึกอบรมใหม่</p>
            <div class="columns is-mobile">
              <div class="column is-4 has-text-right">

            {{ 'Days' | translate }}: <br/>
            {{ 'Streak' | translate }}: <br>
            {{ 'Points' | translate }}: <br/>
            {{ 'Finished Workouts' | translate }}: 
              </div>
              <div class="column">

            <span class="has-text-black">{{ days }}</span><br/>
            <span class="has-text-black">{{ streak }}</span><br>
            <span class="has-text-black">{{ points }}</span><br/>
            <span class="has-text-black">{{ finished }}</span>
              </div>
              <div class="column has-text-right">
                <router-link :to="{ name: 'EatingPlan' }" class="button has-background-primary" style="border-color:#363636;width:7rem;height:7rem;">
                  <img  src="@/../static/food-kyf.svg" style="width:7rem;">
                </router-link>
              </div>
            </div>
      </div>
    </div>
    <div style="height: 20rem;overflow: hidden;position: relative;">
      <img style="max-width:36%;position:absolute;right:0;" src="@/../static/kfit/workout.png">
      <div style="max-width:62%;position:absolute;left:0;">
        <ul class="steps is-vertical is-small p-t-md p-l-sm">
          <li :class="'steps-segment' + (counter == 0 ? ' is-active' : ' has-text-grey')">
            <span :class="'steps-marker' + (counter == 0 ? '' : ' is-hollow')"></span>
            <div class="steps-content step-1">
              <p class="is-size-6 lh-1">1 {{ 'Day' | translate }}</p>
            </div>
            <div class="steps-content step-2">
              <router-link :class="'is-size-6 lh-1' + (counter == 0 ? ' has-text-white' : ' has-text-grey')" :to="{ name: 'Training' }">{{ $t('W workouts with R repetitions', { W: 9, R: 5 }) }}</router-link>
            </div>
          </li>
          <li :class="'steps-segment' + (counter == 1 ? ' is-active' : ' has-text-grey')">
            <span :class="'steps-marker' + (counter == 1 ? '' : ' is-hollow')"></span>
            <div class="steps-content step-1">
              <p class="is-size-6 lh-1">2 {{ 'Day' | translate }}</p>
            </div>
            <div class="steps-content step-2">
              <router-link :class="'is-size-6 lh-1' + (counter == 1 ? ' has-text-white' : ' has-text-grey')" :to="{ name: 'Training' }">{{ $t('W workouts with R repetitions', { W: 10, R: 5 }) }}</router-link>
            </div>
          </li>
          <li :class="'steps-segment' + (counter == 2 ? ' is-active' : ' has-text-grey')">
            <span :class="'steps-marker' + (counter == 2 ? '' : ' is-hollow')"></span>
            <div class="steps-content step-1">
              <p class="is-size-6 lh-1">3 {{ 'Day' | translate }}</p>
            </div>
            <div class="steps-content step-2">
              <router-link :class="'is-size-6 lh-1' + (counter == 2 ? ' has-text-white' : ' has-text-grey')" :to="{ name: 'Training' }">{{ $t('W workouts with R repetitions', { W: 12, R: 5 }) }}</router-link>
            </div>
          </li>
          <li :class="'steps-segment' + (counter == 3 ? ' is-active' : ' has-text-grey')">
            <span :class="'steps-marker' + (counter == 3 ? '' : ' is-hollow')"></span>
            <div class="steps-content step-1">
              <p class="is-size-6 lh-1">4 {{ 'Day' | translate }}</p>
            </div>
            <div class="steps-content step-2">
              <p class="is-size-6 lh-1">{{ $t('Take a break') }}</p>
            </div>
          </li>
          <li :class="'steps-segment' + (counter == 4 ? ' is-active' : ' has-text-grey')">
            <span :class="'steps-marker' + (counter == 4 ? '' : ' is-hollow')"></span>
            <div class="steps-content step-1">
              <p class="is-size-6 lh-1">5 {{ 'Day' | translate }}</p>
            </div>
            <div class="steps-content step-2">
              <router-link :class="'is-size-6 lh-1' + (counter == 4 ? ' has-text-white' : ' has-text-grey')" :to="{ name: 'Training' }">{{ $t('W workouts with R repetitions', { W: 9, R: 5 }) }}</router-link>
            </div>
          </li>
          <li :class="'steps-segment' + (counter == 5 ? ' is-active' : ' has-text-grey')">
            <span :class="'steps-marker' + (counter == 5 ? '' : ' is-hollow')"></span>
            <div class="steps-content step-1">
              <p class="is-size-6 lh-1">6 {{ 'Day' | translate }}</p>
            </div>
            <div class="steps-content step-2">
              <router-link :class="'is-size-6 lh-1' + (counter == 5 ? ' has-text-white' : ' has-text-grey')" :to="{ name: 'Training' }">{{ $t('W workouts with R repetitions', { W: 10, R: 5 }) }}</router-link>
            </div>
          </li>
          <li :class="'steps-segment' + (counter == 6 ? ' is-active' : ' has-text-grey')">
            <span :class="'steps-marker' + (counter == 6 ? '' : ' is-hollow')"></span>
            <div class="steps-content step-1">
              <p class="is-size-6 lh-1">7 {{ 'Day' | translate }}</p>
            </div>
            <div class="steps-content step-2">
              <router-link :class="'is-size-6 lh-1' + (counter == 6 ? ' has-text-white' : ' has-text-grey')" :to="{ name: 'Training' }">{{ $t('W workouts with R repetitions', { W: 12, R: 5 }) }}</router-link>
            </div>
          </li>
        </ul>
        </div>
    </div>
    <div style="height: 30rem;overflow: hidden;">
      <img style="max-width:36%;" src="@/../static/kfit/food.jpg">
      <div style="max-width:62%;float: right;">
        <p class="has-text-white p-t-sm">
เราไม่เชื่อในกฎระเบียบที่เข้มงวดการอดหรือแม้แต่อาหาร เราจะแนะนำให้คุณรู้จักกับอาหารเพื่อสุขภาพในช่วง 12 สัปดาห์และทีละขั้นตอน</p>
<p>
คุณไม่จำเป็นต้องเป็นเชฟระดับแนวหน้าและคุณไม่จำเป็นต้องมีอุปกรณ์เครื่องครัวที่ทันสมัยสำหรับอาหารแสนอร่อยของเรา ง่ายรวดเร็วและเหมาะสำหรับการใช้งานทุกวัน! คนที่ทานมังสวิรัติและคนรักเนื้อจะได้รับเงินของพวกเขา</p>
<p>
  ส่วนผสมที่ดีต่อสุขภาพทำให้มัน แน่นอนว่าอาหารมังสวิรัติและอาหารมังสวิรัติในปัจจุบันกำลังเป็นที่นิยม แต่นั่นไม่ได้หมายความว่าเนื้อหรือปลาจะไม่แข็งแรง ทุกคนจะพบได้ที่นี่! และด้วยวัน Veggi ของเราคุณมีคำแนะนำสูตรอาหารอย่างน้อยสัปดาห์ละครั้งเท่านั้นที่เป็นวีแก้นล้วนๆ
</p><p>
อาหารไม่จำเป็นต้องเป็นการสละสิทธิ์เสมอไป กับเราทุกคนจะพบบางสิ่งบางอย่างและบาปเล็ก ๆ น้อย ๆ ที่ได้รับอนุญาต ฮีโร่ไม่ผิดพลาด
</p>
      </div>
    </div>
      <div class="section m-b-xxl">
        <router-link class="button is-rounded-4 is-fullwidth has-background-primary has-text-white m-t-md m-b-md is-size-4" :to="{ name: 'EatingPlan' }">ตรวจสอบแผนการกินของคุณ</router-link>
      </div>

      <div class="has-background-dark" style="position:fixed;bottom:0;left:0;right:0;z-index: 9990;">
          <router-link class="is-fullwidth has-background-primary has-text-white m-t-md m-b-md is-size-3" :to="{ name: 'Training' }">
            <div class="is-fullwidth has-background-primary has-text-white has-text-centered p-sm">
              <span>เริ่มการฝึก! </span>
              <img src="@/../static/svg/play.svg" class="icon" style="height: 3rem;width: 3rem;margin-bottom:-0.75rem !important"></div>
          </router-link>
          <Footer/>
      </div>
      
  </div>
</template>

<script>
import axios from 'axios'
import Header from '@/components/LangKyf/Header'
import Footer from '@/components/LangKyf/Footer'

export default {
  name: 'Home',
  data () {
    let todayTxt = this.$i18n.translate('Take a break')
    if (this.$store.getters.getTrainingDays % 4 < 2) {
      todayTxt = this.$i18n.translate('W workouts with R repetitions', { W: 5, R: 5 })
    } else if (this.$store.getters.getTrainingDays % 4 === 2) {
      todayTxt = this.$i18n.translate('S km stretch', { S: 3 })
    }
    return {
      todayTxt,
      counter: this.$store.getters.getTrainingDays % 4,
      days: this.$store.getters.getTrainingDays,
      streak: this.$store.getters.getTrainingDays,
      points: this.$store.getters.getTrainingDays,
      finished: this.$store.getters.getTrainingDays
    }
  },
  async mounted() {
    if (this.$store.getters.requireSaleId && window !== undefined && window.localStorage instanceof Storage) {
      const saleIdArr = window.location.hash.match(/\?saleId=([a-z0-9]+)/)
      if (saleIdArr instanceof Array && saleIdArr.length == 2) {
        window.localStorage.setItem('saleId', saleIdArr[1])
      }

      const result = await axios.get(`/${ this.$store.getters.apiPrefix }/checkSale/${ window.localStorage.getItem('saleId') }`)
      if (result.data.state === 'unknown') {
        this.$router.push({ name: 'LP' })
      }
    }
  },
  components: {
    Header,
    Footer
  }
}
</script>

<style>
.table-home td {
  border: none !important;
  vertical-align: middle;
}
.lh-1 {
  line-height: 1 !important;
}
.step-2 {
  width: 8rem;
}
.steps.is-vertical .steps-segment:not(:last-child) {
    min-height: 3.5em;
}
.box.is-rounded {
  border-radius: 0.5rem !important;
}
</style>




// WEBPACK FOOTER //
// src/components/LangKyf/TH/Home.vue